
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M26.444 8.636C26.43 3.872 22.21.014 17 0h0c-5.21.014-9.43 3.872-9.444 8.636v7.773M0 16.409h34V38H0z"}}),_c('ellipse',{attrs:{"cx":"17","cy":"25.045","rx":"3.778","ry":"3.455"}}),_c('path',{attrs:{"d":"M17 28.5v4.318"}})])])
          )
        }
      }
    